import { _t } from "@/tools/Utils";

export const classStates = [
  { text: _t("attribute.all"), value: null },
  { text: _t("attribute.haveclass"), value: "haveclass" },
  { text: _t("attribute.waitingforclass"), value: "waitingforclass" },
  { text: _t("attribute.canceled"), value: "canceled" },
  // { text: _t("attribute.full"), value: "full" },
];
